(function () {
  const section = document.querySelector('.product-information.ga-product-page');
  if (!section) return;

  /** @param {HTMLElement} root */
  function updateAddToCartLabel(root) {
    const priceEl = root.querySelector('.price [ref="priceContainer"] .money, .price .money');
    const priceText = priceEl?.textContent?.replace(/\s+/g, ' ').trim();
    const label = root.querySelector('.add-to-cart-text__content > span > span');

    if (!label || !priceText) return;

    label.textContent = `Add to cart — ${priceText}`;
  }

  updateAddToCartLabel(section);

  document.addEventListener('variant:update', () => {
    requestAnimationFrame(() => updateAddToCartLabel(section));
  });

  section.addEventListener('click', async (event) => {
    const buyNow = event.target instanceof Element ? event.target.closest('[data-ga-buy-now]') : null;
    if (!(buyNow instanceof HTMLButtonElement)) return;

    const formComponent = buyNow.closest('product-form-component');
    const form = formComponent?.querySelector('form');
    if (!form || buyNow.disabled) return;

    buyNow.disabled = true;

    try {
      const formData = new FormData(form);
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error('Add to cart failed');

      window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
    } catch {
      buyNow.disabled = false;
    }
  });
})();
